import { AnimatePresence, motion } from 'framer-motion';
import { Link } from '@trg/tlw-ui-component';
import { useHeaderData } from '../../../hooks';
import { selectIsLogin, selectMemberMenu } from '../../../api';

export interface MemberDropdownProps {
  isOpen?: boolean;
}

export function MemberDropdown({ isOpen }: MemberDropdownProps) {
  const data = useHeaderData();
  const isLogin = selectIsLogin(data);
  const memberMenu = selectMemberMenu(data);

  return (
    <AnimatePresence key="member-dropdown">
      {isOpen && (
        <motion.div
          className="tlw-absolute tlw-top-full tlw-w-max tlw-origin-top"
          style={isLogin ? { right: 0 } : { right: '-2em' }}
          initial={{ paddingTop: 0, opacity: 0, scale: 0.75 }}
          animate={{ paddingTop: 24, opacity: 1, scale: 1 }}
          exit={{ paddingTop: 0, opacity: 0, scale: 0.75 }}
          transition={{
            paddingTop: { duration: 0.3 },
            opacity: { duration: 0.25, delay: 0.05 },
            scale: { duration: 0.3 },
          }}
        >
          <ul className="tlw-px-3 tlw-bg-white tlw-rounded-lg tlw-border tlw-border-gray-300">
            {memberMenu.map((item) => (
              <li key={item.link}>
                <Link
                  className="tlw-txt-zh-head-8 tlw-text-txt-700 tlw-block tlw-py-1 tlw-px-3 tlw-duration-300 hover:tlw-text-txt-core"
                  href={item.link}
                  target={item.linkTarget}
                >
                  {item.mainHeading}
                </Link>
              </li>
            ))}
          </ul>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
